module.exports = __webpack_public_path__ + "static/no-assisted.27e5a81e.png";